import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../content/blog';

export function BlogPage() {
  return (
    <section className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[860px]">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
          Journal
        </div>
        <h1 className="font-display mb-4 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.375rem]">
          How the system actually works.
        </h1>
        <p className="mb-12 max-w-[54ch] text-[1.0625rem] leading-[1.7] text-ink-2">
          Short notes from the product — not a newsroom, not customer quotes.
        </p>
        <div className="mk-stagger space-y-3">
          {BLOG_POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="mk-lift block rounded-2xl border border-line bg-panel p-6 shadow-sm hover:border-brand/30"
            >
              <div className="mb-2 text-[0.72rem] font-semibold tracking-widest text-ink-3 uppercase">{post.date}</div>
              <h2 className="font-display mb-2 text-[1.15rem] font-bold text-ink">{post.title}</h2>
              <p className="text-[0.88rem] leading-[1.65] text-ink-3">{post.summary}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
